import React from "react";
import { Container, Typography } from "@material-ui/core";
import noChatBannerImg from "../assets/3793099.jpg";


function NoChatBanner() {
  return (
    <Container >
      <img
        src={noChatBannerImg}
        alt="no-chat-banner-img"
        height="100vw"
        width="100vw"
      />
        <Typography variant="subtitle1">
          No chats to show, click the pink button below to add a chat room
        </Typography>
    </Container>
  );
}

export default NoChatBanner;
